<template>
    <table v-if="records.length" class="stack category-list-group">
        <caption v-text="heading"></caption>
        <thead>
        <tr>
            <th>Document</th>
            <th class="col-1">Size</th>
            <th class="col-1">Modified</th>
            <th class="col-1">Description</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td colspan="4">
                <input
                    type="text"
                    placeholder="Filter by name"
                    class="margin-bottom-0"
                    v-model="search"
                >
            </td>
        </tr>
        </tbody>
        <tbody
            class="items"
            v-for="record in filteredRecords"
            :key="record.value"
        >
        <tr>
            <td>
                <span class="file-icon" :class="record.extension"></span>
                <span class="name">
                    <a v-if="record.has_file" :href="record.url" v-text="record.name"></a>
                    <span v-else v-text="record.name"></span>
                </span>
                <div class="show-for-small-only">
                    <span v-html="artifacts(record)"></span>
                    <div
                        class="excerpt-toggler"
                        v-if="record.excerpt"
                        @click="expand(record.value)"
                    >
                        Description
                    </div>
                </div>
            </td>
            <td class="show-for-medium">
                <span v-if="record.has_file" v-text="record.size"></span>
                <span v-else>---</span>
            </td>
            <td class="show-for-medium">
                <span v-if="record.date" v-text="record.date"></span>
                <span v-else>---</span>
            </td>
            <td class="show-for-medium">
                <span
                    class="excerpt-toggler"
                    v-if="record.excerpt"
                    @click="expand(record.value)"
                >
                    Description
                </span>
                <span v-else>---</span>
            </td>
        </tr>
        <tr v-if="expanded === record.value">
            <td colspan="4">
                <p
                        class="excerpt"
                        v-html="record.excerpt"
                ></p>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    import {AjaxCaller} from '@ssdcode/cms-partials'
    import Input from '../../mixins/Form/Input'

    export default {
        name: 'category-list',
        components: {Input},
        mixins: [AjaxCaller],
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                search: null,
                heading: '',
                records: [],
                expanded: null,
            }
        },
        computed: {
            url() {
                return '/data/category/' + this.id
            },
            filteredRecords() {
                let records = this.records,
                    keyword = (this.search ? this.search.toLowerCase() : null)

                if (keyword) {
                    return records.filter(record => {
                        return record.name.toLowerCase().includes(keyword)
                    })
                }

                return records
            }
        },
        created() {
            this.initialise()
        },
        methods: {
            initialise() {
                this.makeAjaxRequest(
                    this.success,
                    this.failure,
                    {},
                    this.url
                )
            },
            success(response) {
                this.heading = response.data.heading || ''
                this.records = response.data.records || []
            },
            failure(error) {
                throw new Error(error)
            },
            expand(id) {
                this.expanded = this.expanded === id ? null : id
            },
            artifacts(record) {
                let cont = []
                if (record.has_file) {
                    cont.push('<strong>Size:</strong> ' + record.size)
                }
                if (record.date) {
                    cont.push('<strong>Modified:</strong> ' + record.date)
                }
                return cont.join(', ');
            }
        }
    }
</script>